import { AxiosResponse } from "axios";
import LoginService from "pages/login/login.service";
import { axiosRequest } from "../../axios/axios.config";
import { GenericTO } from './../../model/generic.model';

export type TConsultaEstoque = {
    estabelecimento: string,
    tabelaPreco: string | null;
    sku: {
        uuid: string;
        descritivo: string;
        preco: number | null;
        estoque: {
            uuidDeposito: string;
            nomeDeposito: string;
            saldoEstoque: number;
        };
        uuidProduto: string;
    };
};

const ConsultaEstoqueService = () => {
    const path = '/flow';
    const loginService = LoginService();

    return {
        getConsultaEstoque(skuUuid: string, tabelaPrecoUuid: string, estabelecimentosUuid: string[]): Promise<AxiosResponse<TConsultaEstoque[]>> {
            return axiosRequest.get(`${path}/estoque/consulta/${skuUuid}`,
                {
                    headers: loginService.getHeaders(),
                    params: {
                        tabelaPrecoUuid: tabelaPrecoUuid,
                        estabelecimentosUuids: estabelecimentosUuid.join(','),
                    },
                });
        },
        getConsultaEstoquePorProduto(produtoUuid: string, tabelaPrecoUuid: string, estabelecimentosUuid: string[]): Promise<AxiosResponse<TConsultaEstoque[]>> {
            return axiosRequest.get(`${path}/estoque/consulta/produto/${produtoUuid}`,
                {
                    headers: loginService.getHeaders(),
                    params: {
                        tabelaPrecoUuid: tabelaPrecoUuid,
                        estabelecimentosUuids: estabelecimentosUuid.join(','),
                    },
                });
        },
        getProdutosAc(toSearch: string, tabelaPrecoUuid: string): Promise<AxiosResponse<GenericTO[]>> {
            return axiosRequest.get(`${path}/descricao-produto`,
                {
                    headers: loginService.getHeaders(),
                    params: {
                        toSearch: toSearch,
                        tabelaPrecoUUID: tabelaPrecoUuid,
                    },
                });
        },
        getTabelaPreco(toSearch: string): Promise<AxiosResponse<GenericTO[]>> {
            return axiosRequest.get(`tabelapreco/configuracaopedidobalcao`,
                {
                    headers: loginService.getHeaders(),
                    params: {
                        nome: toSearch,
                    }
                });
        },

    };

};

export default ConsultaEstoqueService;
